import { Component, EventEmitter, Input, Output } from '@angular/core';

export type OffCanvasPosition = 'left' | 'right';
export type OffCanvasSize = 'sm' | 'md' | 'lg';

@Component({
  selector: 'shared-off-canvas-filter',
  templateUrl: './off-canvas-filter.component.html',
  styleUrl: './off-canvas-filter.component.scss',
})
export class OffCanvasFilterComponent {
  @Input() title = 'Filtros';
  @Input() description = '';
  @Input() position: OffCanvasPosition = 'right';
  @Input() size: OffCanvasSize = 'md';
  @Input() icon = 'fa-solid fa-filter';
  @Input() toggleLabel = '';

  @Output() opened = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  public isOpen = false;

  open(): void {
    this.isOpen = true;
    this.opened.emit();
  }

  close(): void {
    this.isOpen = false;
    this.closed.emit();
  }

  toggle(): void {
    this.isOpen ? this.close() : this.open();
  }
}
